import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SocialLogin from '../components/SocialLogin';
import AuthLayout from '../components/auth/AuthLayout';
import AuthError from '../components/auth/AuthError';
import DevAuthButton from '../components/auth/DevAuthButton';
import LinkAccountNotice from '../components/auth/LinkAccountNotice';
import PasswordAuthForm from '../components/auth/PasswordAuthForm';
import SignInMethodsLoading from '../components/auth/SignInMethodsLoading';
import { AUTH_LINK_CLASSES } from '../components/auth/authLinkClasses';
import { useAuthStore } from '../store/authStore';
import { useSignInMethods } from '../hooks/useSignInMethods';
import { Panel } from '../components/ui/Panel';

export default function RegisterPage() {
    const navigate = useNavigate();
    const { register, passwordSignUp, clearError } = useAuthStore();
    const [devPending, setDevPending] = useState(false);
    const methods = useSignInMethods();

    useEffect(() => {
        clearError();
    }, [clearError]);

    const goHome = () => navigate('/');

    const handleMockRegister = async () => {
        setDevPending(true);
        try {
            await register({ displayName: 'Developer', email: 'developer@kaeliux.local' });
            goHome();
        } catch (error) {
            console.error('Mock registration failed:', error);
        } finally {
            setDevPending(false);
        }
    };

    return (
        <AuthLayout tagline="Join the galactic conquest">
            <Panel variant="glass" padding="lg" className="flex flex-col gap-2">
                <div className="mb-3 flex flex-col gap-1">
                    <h2 className="text-heading text-content-primary">Create account</h2>
                    <p className="text-content-muted text-body">
                        Already have an account?{' '}
                        <Link to="/login" className={AUTH_LINK_CLASSES}>
                            Sign in
                        </Link>
                    </p>
                </div>

                <LinkAccountNotice />
                <AuthError />

                {!methods ? (
                    <SignInMethodsLoading />
                ) : !methods.emailPassword && methods.social.length === 0 ? (
                    <p className="text-content-secondary text-body">
                        Creating an account isn&apos;t available right now. Please try again later.
                    </p>
                ) : (
                    <>
                        {methods.emailPassword && (
                            <PasswordAuthForm
                                mode="signUp"
                                submitLabel="Create account"
                                onSubmit={async (email, password) => {
                                    await passwordSignUp(email, password);
                                    goHome();
                                }}
                            />
                        )}

                        <SocialLogin onLoginSuccess={goHome} variant="register" divider={methods.emailPassword} />
                    </>
                )}

                <DevAuthButton
                    label="Quick Register (Mock)"
                    loadingLabel="Registering..."
                    isLoading={devPending}
                    onClick={handleMockRegister}
                />

                <p className="mt-6 text-content-muted text-label">
                    By creating an account, you agree to our{' '}
                    <Link to="/terms" className="underline underline-offset-2 hover:text-content-primary">
                        Terms of Service
                    </Link>{' '}
                    and{' '}
                    <Link to="/privacy" className="underline underline-offset-2 hover:text-content-primary">
                        Privacy Policy
                    </Link>
                </p>
            </Panel>
        </AuthLayout>
    );
}
